import {
	type BoundActions,
	createActionsHook,
	createHook,
	createStore,
	type HookActionsFunction,
	type HookFunction,
	type StoreActionApi,
} from 'react-sweet-state';

import type { HubElementPlaceholderExtensionsState } from './types';

const initialState: HubElementPlaceholderExtensionsState = {
	hubElementPlaceholderLocalId: null,
	hubElementPlaceholderPreviewComponent: null,
};

// Actions for managing the Custom Site Extensions state that is shared between the extension and the config panel
const actions = {
	setPreviewContentForHubElementPlaceholder:
		(extensionLocalId: string | null, previewComponent: React.ReactNode | null) =>
		({ setState }: StoreActionApi<HubElementPlaceholderExtensionsState>): void => {
			setState({
				hubElementPlaceholderLocalId: extensionLocalId,
				hubElementPlaceholderPreviewComponent: previewComponent,
			});
		},
};

const HubElementPlaceholderExtensionsStore = createStore({
	initialState,
	actions,
	name: 'HubElementPlaceholderExtensionsStore',
});

export const useHubElementPlaceholderExtensions: HookFunction<
	HubElementPlaceholderExtensionsState,
	BoundActions<
		HubElementPlaceholderExtensionsState,
		{
			setPreviewContentForHubElementPlaceholder: (
				extensionLocalId: string | null,
				previewComponent: React.ReactNode | null,
			) => ({ setState }: StoreActionApi<HubElementPlaceholderExtensionsState>) => void;
		}
	>,
	void
> = createHook(HubElementPlaceholderExtensionsStore);
export const useHubElementPlaceholderExtensionsActions: HookActionsFunction<
	BoundActions<
		HubElementPlaceholderExtensionsState,
		{
			setPreviewContentForHubElementPlaceholder: (
				extensionLocalId: string | null,
				previewComponent: React.ReactNode | null,
			) => ({ setState }: StoreActionApi<HubElementPlaceholderExtensionsState>) => void;
		}
	>
> = createActionsHook(HubElementPlaceholderExtensionsStore);
